<div
  #item
  [queryParams]="params" [routerLinkActive]="'active-nav-item'" [routerLink]="link"
  class="flex flex-col items-center justify-center min-w-[5rem] h-[72px] px-3 rounded-2xl cursor-pointer select-none transition-all duration-200 group relative gap-y-1">

  <!-- DOM order is deliberately label-then-tile, with the visual order restored by `order-*` (#224).
       Reason: the status badge must be announced AFTER the title ("Formulare Beta"), and it must be positioned
       against the 44 px icon tile (see below) — which means it has to be a *descendant* of that tile. Putting
       the tile last in the DOM is what lets both hold at once: assistive tech reads source order (label, then
       the tile's badge), while flex `order` paints the tile above the label as before. Nothing in here is
       focusable, so this does not desynchronise tab order from the visual order. -->
  <span
    class="order-2 text-[11px] font-semibold text-gray-500 group-hover:text-gray-900 transition-colors tracking-tight text-center px-1 w-full whitespace-nowrap leading-tight">
    {{ title }}
  </span>

  <div
    class="order-1 relative flex items-center justify-center w-11 h-11 rounded-xl bg-gray-50 text-gray-400 group-hover:bg-white group-hover:shadow-md group-hover:text-theme-primary-500 transition-all duration-200 mb-1 border border-transparent group-hover:border-theme-primary-100">
    <div class="w-6 h-6 flex items-center justify-center">
      <ng-content></ng-content>
    </div>

    <!-- Status badge (#224). Anchored to the ICON TILE, not to the entry: the entry's width is driven by its
         label, so an entry-relative badge drifted between "Formulare" and the much wider "Lohnbuchhalter" and
         read as inconsistent across the row (#224 follow-up). The tile is a fixed 44 px square on every entry,
         so `-right-2` + `top-0 -translate-y-1/2` puts the pill in the same place on all of them — vertically
         centred on the tile's top edge (half above it, half overlapping) and overhanging the right edge by 8 px.
         Absolutely positioned, so the entry keeps its fixed 72 px height. It sits inside the tile on purpose:
         `.active-nav-item` scales the tile by 1.1 and the badge scales with it, keeping the corner relationship
         intact. Contrast 5.14:1 (#be185d on #fce7f3).
         NOTE: the badge pokes ~3 px above the entry's own box, so the row that hosts these entries must carry
         vertical padding — see the `py-2` on the scroller in navbar-office-item.component.html. -->
    @if (badge(); as badgeLabel) {
      <span
        class="nav-badge absolute top-0 -right-2 z-10 -translate-y-1/2 whitespace-nowrap rounded-full
               bg-theme-primary-100 px-1 py-px text-[10px] font-bold uppercase leading-none tracking-wide
               text-theme-primary-700 ring-1 ring-theme-primary-200 pointer-events-none">
        {{ badgeLabel }}
      </span>
    }
  </div>

  <div
    class="active-indicator absolute -bottom-1 w-1 h-1 bg-theme-primary-500 rounded-full opacity-0 transition-opacity"></div>
</div>
